import { Box, Chip, Modal, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import customTheme from '../../styles/mui_theme'
import {
  helpfulHintPopUpStyles
} from '../../styles/classes/MobilePreviewClasses'

const HelpfulHintPopUp = ({ open, onClose, text }) => {
  const { t } = useTranslation()
  const popUpClasses = helpfulHintPopUpStyles().classes

  return (
    <Modal
        hideBackdrop
        open={open}
        onClose={onClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...customTheme.helpufHintPop }}>
          <Box className={popUpClasses.textContainer}>
            <Typography className={popUpClasses.titleText}>
              {t('mobile_preview.helpful_hint')}
            </Typography>
            <Box sx={{ maxHeight: '100px' }}>
              <Typography className={popUpClasses.hintText}>
                {text}
              </Typography>
            </Box>
          </Box>
          <Box className={popUpClasses.buttonContainer}>
            <Chip
              onClick={onClose}
              label={t('mobile_preview.ok')}
              variant="outlined"
              className={popUpClasses.chipStyles}
            />
          </Box>
        </Box>
      </Modal>
  )
}

export default HelpfulHintPopUp
